import { createSlice } from '@reduxjs/toolkit';
import { fetchAdvertisements, createAdvertisementPlay } from '../actions/adversitementsActions';

const initialState = {
    advertisements: null,
    loading: false,
    error: null,
    playLoading: false, // Для отслеживания загрузки воспроизведения
    playError: null, // Для ошибок воспроизведения
};

const advertisementsSlice = createSlice({
    name: 'advertisements',
    initialState,
    reducers: {
        resetAdvertisementsState: (state) => {
            state.advertisements = null;
            state.loading = false;
            state.error = null;
            state.playLoading = false;
            state.playError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch advertisements
            .addCase(fetchAdvertisements.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.advertisements = null;
            })
            .addCase(fetchAdvertisements.fulfilled, (state, action) => {
                state.loading = false;
                state.advertisements = action.payload;
                state.error = null;
            })
            .addCase(fetchAdvertisements.rejected, (state, action) => {
                state.loading = false;
                state.advertisements = null;
                state.error = action.payload;
            })
            // Create advertisement play
            .addCase(createAdvertisementPlay.pending, (state) => {
                state.playLoading = true;
                state.playError = null;
            })
            .addCase(createAdvertisementPlay.fulfilled, (state) => {
                state.playLoading = false;
                state.playError = null;
            })
            .addCase(createAdvertisementPlay.rejected, (state, action) => {
                state.playLoading = false;
                state.playError = action.payload;
            });
    },
});

export const { resetAdvertisementsState } = advertisementsSlice.actions;
export default advertisementsSlice.reducer;